export const OrderStatus = {
    OPEN: "OPEN",
    IN_PROGRESS: "IN_PROGRESS",
    DONE: "DONE",
    CLOSED: "CLOSED",
};

export const AllowedOrderStatus = {
    OPEN: [OrderStatus.IN_PROGRESS,OrderStatus.CLOSED],
    IN_PROGRESS: [OrderStatus.DONE, OrderStatus.CLOSED],
    DONE: [],
    CLOSED: []
}